import { render, staticRenderFns } from "./rect_value.vue?vue&type=template&id=ed35f69c&scoped=true"
import script from "./rect_value.vue?vue&type=script&lang=js"
export * from "./rect_value.vue?vue&type=script&lang=js"
import style0 from "./rect_value.vue?vue&type=style&index=0&id=ed35f69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed35f69c",
  null
  
)

export default component.exports